import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../../config/firebase";

function DashboardTab() {
  const [eventsCount, setEventsCount] = useState(0);
  const [chaptersCount, setChaptersCount] = useState(0);
  const [visits, setVisits] = useState({
    today: 0,
    sevenDays: 0,
    thirtyDays: 0,
  });

  useEffect(() => {
    const unsubEvents = onSnapshot(collection(db, "events"), (snapshot) => {
      setEventsCount(snapshot.size);
    });

    const unsubChapters = onSnapshot(collection(db, "chapters"), (snapshot) => {
      setChaptersCount(snapshot.size);
    });

    const unsubVisits = onSnapshot(collection(db, "visits"), (snapshot) => {
      const now = new Date();
      let todayCount = 0;
      let sevenCount = 0;
      let thirtyCount = 0;

      snapshot.forEach((doc) => {
        const data = doc.data();
        if (!data.date) return;

        const visitDate = new Date(data.date);
        // Calcul de la différence en jours
        const diffTime = Math.abs(now - visitDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays <= 1 && visitDate.getDate() === now.getDate()) {
          todayCount++;
        }
        if (diffDays <= 7) sevenCount++;
        if (diffDays <= 30) thirtyCount++;
      });

      setVisits({
        today: todayCount,
        sevenDays: sevenCount,
        thirtyDays: thirtyCount,
      });
    });

    return () => {
      unsubEvents();
      unsubChapters();
      unsubVisits();
    };
  }, []);

  return (
    <div className="fade-in">
      <h3>Vue d'ensemble</h3>
      <div className="stats-grid">
        {/* LA CARTE DES VISITES */}
        <div className="stat-card" style={{ gridColumn: "1 / -1" }}>
          <h4>Visiteurs uniques (par session)</h4>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "20px",
            }}
          >
            <div>
              <div className="number" style={{ fontSize: "2.5rem" }}>
                {visits.today}
              </div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#888",
                  textTransform: "uppercase",
                }}
              >
                Aujourd'hui
              </div>
            </div>
            <div>
              <div className="number" style={{ fontSize: "2.5rem" }}>
                {visits.sevenDays}
              </div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#888",
                  textTransform: "uppercase",
                }}
              >
                7 Jours
              </div>
            </div>
            <div>
              <div className="number" style={{ fontSize: "2.5rem" }}>
                {visits.thirtyDays}
              </div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#888",
                  textTransform: "uppercase",
                }}
              >
                30 Jours
              </div>
            </div>
          </div>
        </div>

        <div className="stat-card">
          <h4>Événements actifs</h4>
          <div className="number">{eventsCount}</div>
        </div>

        <div className="stat-card">
          <h4>Chapters ouverts</h4>
          <div className="number">{chaptersCount}</div>
        </div>
      </div>
    </div>
  );
}

export default DashboardTab;
